import { Box, styled } from "@mui/material";
import { colorPickerName } from "../../../../../classes.js";
const SaturationCursor = styled(Box, {
  name: colorPickerName,
  overridesResolver: (_props, styles) => [styles.saturationCursor],
  slot: "SaturationCursor"
})(({ theme }) => ({
  border: `${theme.spacing(0.25)} solid ${(theme.vars ?? theme).palette.common.white}`,
  borderRadius: "50%",
  boxShadow: `0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.2)`,
  cursor: "move",
  height: theme.spacing(2),
  position: "absolute",
  transform: `translate(${theme.spacing(-1)}, ${theme.spacing(-1)})`,
  width: theme.spacing(2),
  zIndex: 100
}));
export {
  SaturationCursor
};
//# sourceMappingURL=SaturationCursor.js.map
